let html2canvasReady = new Promise((resolve)=>{

if(window.html2canvas){

resolve();

return;

}


const script =
document.createElement("script");


script.src =
"https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js";


script.onload = ()=>{

resolve();

};


document.head.appendChild(script);


});

let beads = [];

let currentCategory = "all";

let basePrice = 0;

let dragIndex = null;
let dragElement = null;

let startX = 0;
let startY = 0;

let braceletRotation = 0;


document.addEventListener(
"DOMContentLoaded",
()=>{


let totalElement=document.getElementById("total");


if(totalElement){

basePrice=Number(
totalElement.dataset.basePrice
);

// Wrist Size change

let wristSelect =
document.getElementById("wrist-size");


let wristRange =
document.getElementById("wrist-range");



if(wristSelect && wristRange){


wristSelect.addEventListener(
"change",
()=>{


let value =
wristSelect.value;



if(value==="6.5"){


wristRange.innerHTML =
"6 - 6.5 inch";


}



if(value==="7"){


wristRange.innerHTML =
"6.5 - 7 inch";


}



if(value==="7.5"){


wristRange.innerHTML =
"7 - 7.5 inch";


}



if(value==="8"){


wristRange.innerHTML =
"7.5 - 8 inch";


}

render();

});


}
}





/* 添加珠子 */


document.querySelectorAll(".bead-btn")
.forEach(btn=>{


btn.addEventListener(
"click",
()=>{


addBead({

name:btn.dataset.name,

price:Number(btn.dataset.price),

image:btn.dataset.image,

variant:btn.dataset.variant,

category:btn.dataset.category,

type:btn.dataset.type,

size:Number(btn.dataset.size),

height:Number(btn.dataset.height)


});



});



});






/* 分类 */


document.querySelectorAll(
".category-tabs button"
)
.forEach(btn=>{


btn.onclick=function(){


document.querySelectorAll(
".category-tabs button"
)
.forEach(b=>{

b.classList.remove("active");

});



btn.classList.add("active");



let category=
btn.dataset.category;

currentCategory = category;



document.querySelectorAll(
".bead-btn"
)
.forEach(bead=>{


let beadCategory=
bead.dataset.category || "";



if(category==="in-use"){



let name =
bead.dataset.name;



let exists =
beads.some(
b=>b.name===name
);



if(exists){

bead.style.display="flex";

}
else{

bead.style.display="none";

}



}



else if(

category==="all" ||

beadCategory===category ||

beadCategory===""

){


bead.style.display="flex";


}


else{


bead.style.display="none";


}


});


};


});






let cart=document.getElementById("add-cart");


if(cart){

cart.onclick=addCart;

}



render();


/* =====================
价格详情展开
===================== */

let priceButton =
document.getElementById("total-button");


let pricePopup =
document.getElementById("price-popup");


let arrow =
document.querySelector(".price-arrow");


if(priceButton && pricePopup){


priceButton.onclick=function(){


if(pricePopup.style.display==="block"){


pricePopup.style.display="none";


if(arrow){

arrow.innerHTML="▼";

}


}
else{


pricePopup.style.display="block";


if(arrow){

arrow.innerHTML="▲";

}


}


};


}


});








function addBead(bead){



if(beads.length>=50){


alert("Maximum 50 components");


return;


}



beads.push(bead);



render();



}








function removeBead(index){


beads.splice(index,1);


render();


}

function getBraceletSize(){

let totalSize = 0;


beads.forEach(b=>{


totalSize += Number(b.size) || 0;


});


return totalSize;


}






function getCircle(){


return document.getElementById(
"bracelet"
);


}








function getPosition(slot){

let circle=getCircle();

let size=circle.offsetWidth;

let center=size/2;

let radius=size/2-1;


/* 根据每个组件的实际宽度计算圆周占位 */

let totalWidth=0;

beads.forEach(b=>{

let width=
Number(b.size) || 1;

totalWidth+=width;

});


/* 当前组件之前已经占用的宽度 */

let beforeWidth=0;

for(let i=0;i<slot;i++){

let width=
Number(beads[i].size) || 1;

beforeWidth+=width;

}


/* 当前组件自己的宽度 */

let currentWidth=
Number(beads[slot].size) || 1;


/* 当前组件中心所处的圆周比例 */

let positionRatio=
(beforeWidth+(currentWidth/2))/
totalWidth;


/* 转换成角度 */

let angle=
(positionRatio*360)-90+braceletRotation;


return{

x:center+
radius*
Math.cos(
angle*Math.PI/180
),

y:center+
radius*
Math.sin(
angle*Math.PI/180
)

};

}









function render(){



let circle=getCircle();


if(!circle)return;

let watermark=
circle.querySelector(".bracelet-watermark");

if(!watermark){

watermark=
document.createElement("div");

watermark.className=
"bracelet-watermark";

watermark.innerHTML="VYLORA";

circle.appendChild(watermark);

}


// 重点修复
// 不删除垃圾桶
circle.querySelectorAll(
".bracelet-slot,.bead"
)
.forEach(el=>{

el.remove();

});






// 生成18个空位


for(let i=0;i<beads.length;i++){


let pos=getPosition(i);



let slot=document.createElement(
"div"
);


slot.className=
"bracelet-slot";



slot.style.left=
pos.x+"px";


slot.style.top=
pos.y+"px";



circle.appendChild(slot);



}








let total=0;



beads.forEach(b=>{


total+=b.price;


});


let inUseTab =
document.getElementById("in-use-tab");


if(inUseTab){


if(beads.length>0){


inUseTab.style.display="block";


}
else{


inUseTab.style.display="none";


}


}

let countBox=document.getElementById("bead-count");


if(countBox){


let size = getBraceletSize();


countBox.innerHTML = 
(size/10).toFixed(1) + " cm";

let inchBox =
document.getElementById("size-inch");


if(inchBox){

inchBox.innerHTML =
(size/25.4).toFixed(1) + " inch";

}

}





let totalBox=
document.getElementById("total");



let beadTotal=
document.getElementById("bead-total");





if(totalBox){

totalBox.innerHTML=
(basePrice+total).toFixed(2);

}

// Fit Status

let fitStatus =
document.getElementById("fit-status");


let wristSelect =
document.getElementById("wrist-size");



if(fitStatus && wristSelect){


let wrist =
wristSelect.value;



let currentInch =
(getBraceletSize()/25.4);



let min=0;
let max=0;



if(wrist==="6.5"){

min=6;
max=6.5;

}


if(wrist==="7"){

min=6.5;
max=7;

}


if(wrist==="7.5"){

min=7;
max=7.5;

}


if(wrist==="8"){

min=7.5;
max=8;

}





let averageSize = 8;


if(beads.length > 0){


let totalComponentSize = 0;


beads.forEach(b=>{


totalComponentSize += Number(b.size) || 0;


});


averageSize =
totalComponentSize / beads.length;


}




if(currentInch < min){


let need =
Math.ceil(
((min-currentInch)*25.4) / averageSize
);

fitStatus.className="warning";

fitStatus.innerHTML =
"Add about " + need + " pieces";



}



else if(
currentInch >= min - 0.1 &&
currentInch <= max + 0.1
){

fitStatus.className="perfect";

fitStatus.innerHTML =
"Perfect Fit ✓";

}



else{


let extra =
Math.ceil(
((currentInch-max)*25.4) / averageSize
);

fitStatus.className="over"; 

fitStatus.innerHTML =
"Remove about " + extra + " pieces";


}



}


if(beadTotal){

beadTotal.innerHTML=
total.toFixed(2);

}
let popupBead =
document.getElementById("popup-bead-total");


let popupTotal =
document.getElementById("popup-total");



if(popupBead){


popupBead.innerHTML =
total.toFixed(2);


}



if(popupTotal){


popupTotal.innerHTML =
(basePrice+total).toFixed(2);


}








// 显示珠子


/* 显示珠子 */

beads.forEach(

(b,index)=>{

let pos=

getPosition(index);


let div=

document.createElement(

"div"

);


div.className="bead";


div.dataset.index=index;


div.style.left=

pos.x+"px";


div.style.top=

pos.y+"px";

div.style.zIndex=

Math.round(pos.y)+10;

let depth=

(pos.y / circle.offsetHeight);

let shadow=

0.08 +

(depth * 0.16);

div.style.filter=

"drop-shadow(0 0 2px rgba(255,255,255,.95)) " +

"drop-shadow(0 2px 3px rgba(0,0,0,"+

shadow+

"))";

let img=

document.createElement(

"img"

);

img.src=b.image;

/* 根据圆圈位置自动旋转 */

/* 根据珠子当前实际位置计算旋转角度 */

let center=

circle.offsetWidth/2;

let dx=

pos.x-center;

let dy=

pos.y-center;

let angle=

Math.atan2(dy,dx)

*

180/Math.PI;


/* 沿着手链圆周方向旋转 */

let rotation=

angle+90;


/* 根据后台尺寸自动计算珠子大小 */

let beadSize=

Number(b.size) || 8;

let scale=

beadSize / 8;


/* 限制最小和最大显示比例 */

scale=

Math.max(0.65,Math.min(scale,1.8));


/* Spacer */
/* Spacer 使用独立的 Width + Height 尺寸系统 */

if(

b.type &&

b.type.toLowerCase()==="spacer"

){

let width =

Number(b.size) || 8;

let height =

Number(b.height) || 8;


/* Spacer 自己的 8mm 基准 */

let spacerBaseWidth = 50;

let spacerBaseHeight = 50;


/* 根据真实 Width / Height 换算 */

let displayHeight =

spacerBaseHeight *

(height / 8);


/* 根据 Spacer 图片自身比例计算宽度 */

let imageRatio =

img.naturalWidth && img.naturalHeight

? img.naturalWidth / img.naturalHeight

: 1;


/* Width 和 Height 都按照后台真实尺寸计算 */

let spacerWidthFactor = 1.8;

let displayWidth =

displayHeight *

(width / height) *

imageRatio *

spacerWidthFactor;


/* 设置 Spacer 实际显示区域 */

div.style.width =

displayWidth + "px";

div.style.height =

displayHeight + "px";


div.style.minWidth =

displayWidth + "px";

div.style.minHeight =

displayHeight + "px";


div.style.maxWidth =

displayWidth + "px";

div.style.maxHeight =

displayHeight + "px";


/* 图片完全跟随 Spacer 尺寸 */

img.style.width =

"100%";

img.style.height =

"100%";

img.style.maxWidth =

"none";

img.style.maxHeight =

"none";


/* 不保持原图片比例 */

img.style.objectFit =

"fill";


/* Spacer 保持圆周方向旋转 */

div.style.transform =

"translate(-50%,-50%) rotate("+

rotation+

"deg)";

}


/* 普通珠子 */

else{

div.style.transform=

"translate(-50%,-50%) rotate("+

rotation+

"deg) scale("+

scale+

")";

}


div.appendChild(img);


addDrag(div);


circle.appendChild(div);


});



function applyCategoryFilter(){


document.querySelectorAll(
".bead-btn"
)
.forEach(bead=>{


let category =
currentCategory;


let beadCategory =
bead.dataset.category || "";



if(category==="in-use"){


let exists =
beads.some(
b=>b.name===bead.dataset.name
);



if(exists){

bead.style.display="flex";

}
else{

bead.style.display="none";

}


}


else if(

category==="all" ||

beadCategory===category ||

beadCategory===""

){


bead.style.display="flex";


}

else{


bead.style.display="none";


}


});


}



renderList();

applyCategoryFilter();

updateBeadCounts();

}









function addDrag(el){


function start(e){


e.preventDefault();


dragElement=el;


dragIndex=
Number(el.dataset.index);

let trash =
document.getElementById("trash-bin");

if(trash){

trash.style.display="flex";

}

let p=
e.touches ?
e.touches[0]:
e;



startX=p.clientX;

startY=p.clientY;



document.addEventListener(
"mousemove",
move
);


document.addEventListener(
"mouseup",
end
);



document.addEventListener(
"touchmove",
move,
{passive:false}
);



document.addEventListener(
"touchend",
end
);



}






function move(e){


if(!dragElement)return;



e.preventDefault();



let p=
e.touches?
e.touches[0]:
e;



let dx=
p.clientX-startX;


let dy=
p.clientY-startY;



dragElement.style.left=
dragElement.offsetLeft+dx+"px";


dragElement.style.top=
dragElement.offsetTop+dy+"px";



startX=p.clientX;

startY=p.clientY;



}






function end(){

if(!dragElement)return;


let trash=
document.getElementById(
"trash-bin"
);


/* 判断是否拖进垃圾桶 */

if(trash){

let t=
trash.getBoundingClientRect();

let b=
dragElement.getBoundingClientRect();


let x=
b.left+b.width/2;

let y=
b.top+b.height/2;


if(
x>t.left &&
x<t.right &&
y>t.top &&
y<t.bottom
){

beads.splice(
dragIndex,
1
);

dragElement=null;

render();

removeEvents();

if(trash){

trash.style.display="none";

}

return;

}

}


/* 正常交换位置 */

let slot=
getNearestSlot(
dragElement
);


if(
slot!==dragIndex &&
beads[slot]
){

let temp=
beads[dragIndex];

beads[dragIndex]=
beads[slot];

beads[slot]=
temp;

}


dragElement=null;

render();

removeEvents();


/* 松手后，无论有没有删除，都隐藏垃圾桶 */

let trashAfter=
document.getElementById(
"trash-bin"
);

if(trashAfter){

trashAfter.style.display="none";

}

}







function removeEvents(){


document.removeEventListener(
"mousemove",
move
);


document.removeEventListener(
"mouseup",
end
);


document.removeEventListener(
"touchmove",
move
);


document.removeEventListener(
"touchend",
end
);


}




el.addEventListener(
"mousedown",
start
);



el.addEventListener(
"touchstart",
start,
{passive:false}
);



}









function getNearestSlot(el){

let circle=getCircle();

let rect=
circle.getBoundingClientRect();

let bead=
el.getBoundingClientRect();

let x=
bead.left+
bead.width/2;

let y=
bead.top+
bead.height/2;

let bestSlot=0;

let bestDistance=Infinity;


/* 只计算当前实际存在的珠子位置 */

for(let i=0;i<beads.length;i++){

let pos=
getPosition(i);

let slotX=
rect.left+
pos.x;

let slotY=
rect.top+
pos.y;

let dx=
x-slotX;

let dy=
y-slotY;

let distance=
Math.sqrt(
dx*dx+
dy*dy
);


if(
distance<bestDistance
){

bestDistance=
distance;

bestSlot=
i;

}

}


return bestSlot;

}



function updateBeadCounts(){


document.querySelectorAll(".bead-btn")
.forEach(btn=>{


let name =
btn.dataset.name;


let count =
beads.filter(
b=>b.name===name
).length;



let badge =
btn.querySelector(
".bead-count-badge"
);



if(!badge)return;



if(count>0){

badge.innerHTML=count;

badge.style.display="flex";

btn.classList.add("selected");

btn.style.border="1px solid #d4b483";

btn.style.background="#faf5ed";

}
else{

badge.innerHTML="";

badge.style.display="none";

btn.classList.remove("selected");

btn.style.border="1px solid #eee5d8";

btn.style.background="white";

}


});


}





function renderList(){


let list=
document.getElementById(
"design-list"
);



if(!list)return;



list.innerHTML="";



if(beads.length===0){

list.innerHTML=
"No beads selected";


return;


}



beads.forEach(
(b,i)=>{


let div=
document.createElement(
"div"
);



div.className=
"design-item";



div.innerHTML=
`
${i+1}. ${b.name}

<span class="remove">
✕
</span>
`;



div.querySelector(".remove")
.onclick=
()=>removeBead(i);



list.appendChild(div);



});


}




async function savePreview(){

await html2canvasReady;    

let bracelet =
document.getElementById("bracelet");

let preview =
document.getElementById("design-preview");


if(!bracelet || !preview){

alert("Preview error");

return Promise.reject();

}


preview.innerHTML="";


let clone =
bracelet.cloneNode(true);


clone.style.position="relative";
clone.style.left="0";
clone.style.top="0";


preview.appendChild(clone);



return html2canvas(preview,{
backgroundColor:"#ffffff",
scale:2
})
.then(canvas=>{


console.log("preview image created",canvas);



return new Promise((resolve,reject)=>{


canvas.toBlob(function(blob){


let formData = new FormData();


formData.append(
"file",
blob
);


formData.append(
"upload_preset",
"bracelet_upload"
);



fetch(
"https://api.cloudinary.com/v1_1/qab3eeze/image/upload",
{
method:"POST",
body:formData
}
)
.then(res=>res.json())
.then(data=>{


console.log(
"Cloudinary URL:",
data.secure_url
);



window.braceletImageURL =
data.secure_url;



resolve(data.secure_url);



})
.catch(err=>{


console.log(err);

reject(err);


});



},
"image/webp",
0.95
);


});


});

}




async function addCart(){


let cartBtn =
document.getElementById("add-cart");


if(cartBtn){

cartBtn.disabled=true;

cartBtn.innerHTML=
'<span class="cart-loading-spinner"></span> ✨ Creating Your Bracelet...';

}


// 让按钮立即显示
await new Promise(
resolve=>setTimeout(resolve,50)
);



if(!window.braceletImageURL){


if(cartBtn){

cartBtn.innerHTML=
'<span class="cart-loading-spinner"></span> Creating Bracelet Preview...';

}


await new Promise(
resolve=>setTimeout(resolve,50)
);


await savePreview();


}
   
if(cartBtn){

cartBtn.innerHTML=
'<span class="cart-loading-spinner"></span> ☁️ Saving Your Bracelet...';

}


await new Promise(
resolve=>setTimeout(resolve,50)
);

let items=[];

// 创建本次DIY唯一ID
let diyId = "bracelet_" + Date.now();

items.push({

id:"48034667135127",

quantity:1,

properties:{

"_diy_id":
diyId,

"Design Image":
window.braceletImageURL || "",


"Bracelet Size":
document.getElementById("wrist-size")?.value || "",


"Beads":
Object.entries(
  beads.reduce((counts,b)=>{
    counts[b.name] =
      (counts[b.name] || 0) + 1;
    return counts;
  },{})
)
.map(([name,count])=>name+" × "+count)
.join(", ")


}

});




beads.forEach(b=>{

items.push({

id:b.variant,
quantity:1,

properties:{

"_diy_id":
diyId

}

});

});


if(cartBtn){

cartBtn.innerHTML=
'<span class="cart-loading-spinner"></span> 🛒 Adding To Cart...';

}


await new Promise(
resolve=>setTimeout(resolve,50)
);


fetch(
"/cart/add.js",
{

method:"POST",

headers:{

"Content-Type":
"application/json"

},


body:JSON.stringify({

items:items

})


}

)
.then(()=>{

window.location.href="/cart";

})
.catch(()=>{


let cartBtn =
document.getElementById("add-cart");


if(cartBtn){

cartBtn.disabled=false;

cartBtn.innerHTML=
"Save & Preview";

}


});



}



/* =========================
   Bracelet Rotation Area
========================= */

document.addEventListener("DOMContentLoaded",()=>{

let rotateArea =
document.getElementById("rotate-area");

let bracelet =
document.getElementById("bracelet");

if(!rotateArea || !bracelet)return;


let rotating = false;

let lastAngle = 0;



function getPointerAngle(e){

let point =
e.touches ?
e.touches[0] :
e;

let rect =
bracelet.getBoundingClientRect();


let centerX =
rect.left + rect.width / 2;

let centerY =
rect.top + rect.height / 2;


return Math.atan2(
point.clientY - centerY,
point.clientX - centerX
);

}



/* 开始旋转 */

function rotateStart(e){

e.preventDefault();

rotating = true;

lastAngle =
getPointerAngle(e);

}



/* 旋转 */

function rotateMove(e){

if(!rotating)return;

e.preventDefault();


let currentAngle =
getPointerAngle(e);


let delta =
currentAngle - lastAngle;


/* 防止跨越 -180 / 180 度时突然跳转 */

if(delta > Math.PI){

delta -= Math.PI * 2;

}


if(delta < -Math.PI){

delta += Math.PI * 2;

}


lastAngle =
currentAngle;


/* 弧度 → 角度 */

braceletRotation +=
delta * 180 / Math.PI;


/* 重新绘制手串 */

render();

}



/* 停止旋转 */

function rotateEnd(){

rotating = false;

}



/* 手机 */

rotateArea.addEventListener(
"touchstart",
rotateStart,
{passive:false}
);


rotateArea.addEventListener(
"touchmove",
rotateMove,
{passive:false}
);


rotateArea.addEventListener(
"touchend",
rotateEnd
);


rotateArea.addEventListener(
"touchcancel",
rotateEnd
);



/* 电脑鼠标 */

rotateArea.addEventListener(
"mousedown",
rotateStart
);


document.addEventListener(
"mousemove",
rotateMove
);


document.addEventListener(
"mouseup",
rotateEnd
);


});